import { render, staticRenderFns } from "./IconFilePowerpoint.vue?vue&type=template&id=9d001408&"
import script from "./IconFilePowerpoint.vue?vue&type=script&lang=ts&"
export * from "./IconFilePowerpoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports